  <table *ngIf="displayOverlaps.length > 0">
    <tr>
      <th>Models</th>
      <th></th>
      <th>Overlapping activity</th>
    </tr>
  <tr *ngFor="let overlap of displayOverlaps">
    <td>
      <div *ngFor="let modelIdTitle of overlap.modelIdTitles">
        <div *ngIf="overlap.enabledByGene">
          <a routerLink="/gocam/pombase-view/gene/{{modelIdTitle[0]}}/{{overlap.enabledByGene.uniquename}}/{{overlap.enabledByGene.displayName()}}">
            {{modelIdTitle[0]}} - {{modelIdTitle[1]}}
          </a>
        </div>
        <div *ngIf="overlap.enabledByChemical || overlap.enabledByComplex">
          <a routerLink="/gocam/pombase-view/docs/{{modelIdTitle[0]}}">
            {{modelIdTitle[0]}} - {{modelIdTitle[1]}}
          </a>
        </div>
      </div>
    </td>
    <td>
      <div class="merged-link" *ngIf="overlap.enabledByGene">
        <a routerLink="/gocam/pombase-view/docs/{{overlap.mergedIds}}/{{overlap.enabledByGene.uniquename}}/{{overlap.enabledByGene.displayName()}}">
          View merged model
        </a>
      </div>
      <div *ngIf="overlap.enabledByChemical || overlap.enabledByComplex">
        <a routerLink="/gocam/pombase-view/docs/{{overlap.mergedIds}}">
          View merged model
        </a>
      </div>
    </td>
    <td>
      <div>
        <a *ngIf="overlap.node_id.startsWith('GO:')" routerLink="/term/{{overlap.node_id}}">
          {{overlap.node_label}}
        </a>
     </div>
     <div>
        enabled by
        <app-gene-link *ngIf="overlap.enabledByGene" [long]="false" [gene]="overlap.enabledByGene"></app-gene-link>
        <span *ngIf="overlap.enabledByChemical">{{overlap.enabledByChemical.label}} ({{overlap.enabledByChemical.id}})</span>
        <span *ngIf="overlap.enabledByComplex">
          <span *ngIf="overlap.enabledByComplex.id.startsWith('GO:')">
            <a routerLink="/term/{{overlap.enabledByComplex.id}}">{{overlap.enabledByComplex.label}}</a>
          </span>
          <span *ngIf="!overlap.enabledByComplex.id.startsWith('GO:')">
            {{overlap.enabledByComplex.label}} ({{overlap.enabledByComplex.id}})
          </span>
        </span>
      </div>
      <div *ngIf="overlap.occursInComponents">
        <div *ngFor="let occursInComponent of overlap.occursInComponents">
        <div *ngIf="occursInComponent.id.startsWith('GO:')">
          occurs in <a routerLink="/term/{{occursInComponent.id}}">{{occursInComponent.label}}</a>
        </div>
        <div *ngIf="!occursInComponent.id.startsWith('GO:')">
          occurs in {{occursInComponent.label}} ({{occursInComponent.id}})
        </div>
        </div>
      </div>

      <div *ngIf="overlap.part_of_process">
        part of <a routerLink="/term/{{overlap.part_of_process.id}}">{{overlap.part_of_process.label}}</a>
      </div>
    </td>
  </tr>
</table>

